import React, { Component } from 'react';
import { checkMobile, checkCode, register, getProvCityCountyFlag, getFrontUserCode, setLogin } from "@/fetch/api/token.js";
import { getRegisterConfig } from "@/fetch/api/personal.js";
import { Input, Checkbox, Button, Form, message, Cascader } from 'antd';
import { city } from "@/utils/cascaderArea";
import MessageCode from '../../../PersonalCenter/PersonalSetting/components/MessageCode';
import jsrsasign from 'jsrsasign';
import { unloginQestion } from '@/fetch/api/question.js';
import { Local } from '@/utils/local.js';
import { Encrypt } from '@/utils/encrypt.js';
import WebSocketProxy from '@/utils/webSocket';

const CryptoJS = require('crypto-js'); //引用AES源码js


export class RegisterBox extends Component {
  state = {
    userName: undefined,
    //用户名
    captchaCode: undefined,
    //验证码
    phoneNumber: undefined,
    //电话号
    password: undefined,
    //密码
    userAgreementChecked: false,
    //用户协议
    emailVlue: undefined,
    provCityCountyFlag: false,
    currentDomain: window.location.origin.indexOf('localhost') == -1 ? window.location.origin : 'http://ts.dev-s.yunduoketang.cn',
    hostname: window.location.origin.indexOf('localhost') == -1 ? window.location.hostname : 'ts.dev-s.yunduoketang.cn',
    province: undefined,
    //省
    cities: undefined,
    //市
    area: undefined //区

  }; //加密（AES/ECB/PKCS5Padding默认加密算法）

  encrypt = word => {
    const key = CryptoJS.enc.Utf8.parse('a1b2c3d4e5012345'); //16位

    let encrypted = '';

    if (typeof word == 'string') {
      let srcs = CryptoJS.enc.Utf8.parse(word);
      encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
    } else if (typeof word == 'object') {
      //对象格式的转成json字符串
      let data = JSON.stringify(word);
      let srcs = CryptoJS.enc.Utf8.parse(data);
      encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
    }

    return encrypted.toString();
  }; // 加密密码

  encryptPassword = (psd, key) => {
    console.log(psd, key, 'asdasdasdad');
    var encrypt_rsa = new jsrsasign.RSAKey();
    var prefix = "-----BEGIN PUBLIC KEY-----\n";
    var suffix = "\n-----END PUBLIC KEY-----";
    var publicKey = prefix + key + suffix;
    encrypt_rsa = jsrsasign.KEYUTIL.getKey(publicKey);
    var encStr = encrypt_rsa.encrypt(psd, encrypt_rsa);
    return encStr;
  };
  goRegister = e => {
    e.preventDefault();
    let {
      userName,
      captchaCode,
      phoneNumber,
      password,
      userAgreementChecked,
      hostname,
      province,
      cities,
      area,
      provCityCountyFlag
    } = this.state;
    let {
      registerConfig
    } = this.props;
    message.destroy();

    if (registerConfig.usernameFlag == 1 && !userName) {
      message.warning('请输入用户名');
      return;
    }

    if (registerConfig.usernameFlag == 1 && userName && !/^[a-zA-Z]{1}[a-zA-Z0-9_]{3,19}$/.test(userName)) {
      return;
    }

    if (registerConfig.mobileFlag == 1 && !phoneNumber) {
      message.warning('请输入手机号');
      return;
    }

    if (registerConfig.mobileFlag == 1 && !captchaCode) {
      message.warning('请输入验证码');
      return;
    }

    if (!password) {
      message.warning('请输入密码');
      return;
    }

    if (provCityCountyFlag && (!province || !cities)) {
      message.warning('请填写省市县');
      return;
    }

    if (registerConfig.registerAgreementFlag && !userAgreementChecked) {
      message.warning('请同意用户协议');
      return;
    }

    if (registerConfig.mobileFlag == 1) {
      var {
        rember_x,
        rember_y
      } = this.child.state;
    }

    let params = {
      mobile: phoneNumber == undefined ? null : phoneNumber,
      //手机号
      password,
      //密码
      smsCode: captchaCode == undefined ? null : captchaCode,
      //短信验证码
      username: userName == undefined ? null : userName,
      //用户名
      xy: `${registerConfig.mobileFlag == 1 ? rember_x : 0}_${registerConfig.mobileFlag == 1 ? rember_y : 0}`,
      //滑块位置
      province: province == undefined ? null : province,
      //省
      city: cities == undefined ? null : cities,
      //市
      county: area == undefined ? null : area //区

    };
    register(params).then(res => {
      message.destroy();

      if (res.flag == 'success') {
        message.success('注册成功');
        setLogin({
          "account": params.mobile || params.username,
          "password": this.encryptPassword(params.password, this.props.loginConfig.publicKey),
          "remeberMe": 0,
          //1记住 0不记
          "type": 1
        }).then(res => {
          if (res.code == 1 && res.data.flag) {
            console.log(res.data.user, 'res.data.');
            let userInfo = {
              userId: res.data.user.id
            };
            Local.set('userInfo', Encrypt(JSON.stringify(userInfo)));
            getFrontUserCode({
              caInfo: this.encrypt(`${res.data.user.id}~${hostname}`)
            }).then(async result => {
              console.log(result, 'resultresultresultresult');

              if (result.code == 1) {
                WebSocketProxy.loginWebsocket('general', 'login', 'login', res.data.user.id);
                let link = '';
                let relRecordId = ''; // 处理未登录做题同步

                if (Local.get('clientId') && Local.get(Local.get('clientId'))) {
                  let currentClientId = Local.get('clientId');
                  let params = {
                    schoolId: res.data.user.schoolId,
                    currentId: Local.get('unLoginRecordId') || ''
                  };
                  let data = Local.get(currentClientId);
                  let unLoginDoingRes = await unloginQestion(params, data);

                  if (unLoginDoingRes.code === '1') {
                    relRecordId = unLoginDoingRes.data;
                    Local.remove('clientId');
                    Local.remove(currentClientId);
                    Local.remove('paperId');
                    Local.remove('unLoginRecordId');
                  }
                }

                if (window.location.href.indexOf('/lib/subject/doing') !== -1 || window.location.href.indexOf('/lib/subject/report') !== -1) {
                  // 做题页地址
                  let hrefArr = window.location.hash.split('/');
                  hrefArr[4] = relRecordId;
                  let hrefStr = hrefArr.join('/');
                  window.location.href = window.location.origin + '/s/pc/' + hrefStr;
                }

                if (window.location.href.includes('?')) {
                  link = `${window.location.href}&code=${result.data}&schoolId=${res.data.user.schoolId}`;
                } else {
                  link = `${window.location.href}?code=${result.data}&schoolId=${res.data.user.schoolId}`;
                }

                Local.remove('token');
                Local.remove('parentId'); // Local.remove('refresh_token')

                if (link.indexOf('/home/index') > -1) {
                  Local.set('indexShowFlag', true);
                } else {
                  Local.remove('indexShowFlag');
                }

                window.location.replace(link);
                window.location.reload();
              } else {
                message.warning('登录失败');
              }
            });
          } else {
            message.warning(res.data.msg);
          }
        });
      } else {
        message.warning(res && res.msg || '注册失败');
      }
    });
  };
  bindRef = ref => {
    this.child = ref;
  }; //获取滑块验证码前根据需要校验手机号

  validateMobile = () => {
    this.props.form.validateFields(['mobile'], (errors, values) => {
      if (!errors) {
        this.child.onShowSlider();
      }
    });
  };
  onCheckMobile = (rule, value, callback) => {
    if (!value) {
      callback("请输入手机号码");
    } else if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(value)) {
      callback("手机号格式不正确");
    } else {
      checkMobile({
        mobile: value || 0,
        domain: this.state.currentDomain,
        email: this.state.emailVlue || 0
      }).then(res => {
        if (res) {
          callback();
        } else {
          callback('手机号已绑定');
        }
      });
    }
  };
  onChecUserName = (rule, value, callback) => {
    if (!value) {
      callback("请输入用户名");
    } else if (!/^[a-zA-Z]/.test(value)) {
      callback("用户名必须以字母开头");
    } else if (!/^[a-zA-Z]{1}[a-zA-Z0-9_]{3,19}$/.test(value)) {
      callback("用户名只能以字母、数字、下划线的4-20个字符组成");
    } else {
      checkMobile({
        username: value || 0,
        domain: this.state.currentDomain
      }).then(res => {
        if (res) {
          callback();
        } else {
          callback('用户名已绑定');
        }
      });
    }
  };
  onCheckCaptchaCode = (rule, value, callback) => {
    if (!value) {
      callback('短信验证码不能为空!');
    } else {
      console.log(this.state.captchaCode, 'this.state.captchaCode');
      checkCode({
        smsCode: this.state.captchaCode,
        domain: this.state.currentDomain
      }).then(res => {
        if (res) {
          callback();
        } else {
          callback('短信验证码不正确!');
        }
      });
    }
  };

  componentDidMount() {
    // 获取是否展示省市县
    this.getProvCityCountyFlagData();
  }

  getProvCityCountyFlagData() {
    getProvCityCountyFlag().then(res => {
      res.code == '1' && this.setState({
        provCityCountyFlag: res.data
      });
    });
  } // 层级联动选择的内容


  chooseProvCityCounty = (value, selectedOptions) => {
    console.log(value, selectedOptions, 'value, selectedOptions');
    this.setState({
      province: value.length && value[0],
      //省
      cities: value.length && value[1],
      //市
      area: value.length >= 3 ? value[2] : undefined //区

    }, () => {// console.log(this.state.province, this.state.cities, this.state.area, 'province,cities,area');
    });
  };
  goToProcotol = e => {
    e.preventDefault();
    e.stopPropagation();
    window.open(`${window.location.origin}/showRegisterAgreement`, '_blanck');
  };

  render() {
    let {
      userName,
      captchaCode,
      phoneNumber,
      password,
      userAgreementChecked,
      provCityCountyFlag
    } = this.state;
    let {
      registerConfig
    } = this.props; // console.log(registerConfig, '1231231231ksdhfjkso12u3892u148');

    const {
      getFieldDecorator
    } = this.props.form;
    return <div data-inspector-line="274" data-inspector-column="6" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx" className="register-box">
        <Form data-inspector-line="275" data-inspector-column="8" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx" onSubmit={this.goRegister}>
          {
          /* 用户名 */
        }
          {registerConfig && registerConfig.usernameFlag == 1 ? <Form.Item data-inspector-line="280" data-inspector-column="65" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx" hasFeedback>
              {getFieldDecorator('userName', {
            rules: [{
              validator: this.onChecUserName
            }],
            validateTrigger: 'onBlur',
            initValue: userName
          })(<Input data-inspector-line="285" data-inspector-column="17" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx" placeholder="请输入用户名" maxLength={20} prefix={<i data-inspector-line="288" data-inspector-column="24" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx" className="iconfont iconyonghu"></i>} onChange={e => {
            this.setState({
              userName: e.target.value
            });
          }} />)}
            </Form.Item> : null}
          {
          /* 手机号 */
        }
          {registerConfig && registerConfig.mobileFlag == 1 ? <Form.Item data-inspector-line="295" data-inspector-column="63" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx" hasFeedback>
              {getFieldDecorator('mobile', {
            rules: [{
              validator: this.onCheckMobile
            }],
            validateTrigger: 'onBlur'
          })(<Input data-inspector-line="303" data-inspector-column="17" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx" width={188} value={phoneNumber} placeholder="请输入手机号" prefix={<i data-inspector-line="307" data-inspector-column="24" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx" className="iconfont iconshoujihao"></i>} onChange={e => {
            this.setState({
              phoneNumber: e.target.value
            });
          }} />)}
            </Form.Item> : null}
          {registerConfig && registerConfig.mobileFlag == 1 ? <Form.Item data-inspector-line="313" data-inspector-column="63" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx" className="captcha-code">
              {
            /* 验证码 */
          }
              {getFieldDecorator('phoneMessageCode', {
            rules: [{
              validator: this.onCheckCaptchaCode
            }],
            validateTrigger: 'onBlur'
          })(<Input data-inspector-line="321" data-inspector-column="19" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx" placeholder="请输入验证码" prefix={<i data-inspector-line="323" data-inspector-column="26" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx" className="iconfont iconyanzhengma"></i>} value={captchaCode} onChange={e => {
            this.setState({
              captchaCode: e.target.value
            });
          }} />)}
              <MessageCode data-inspector-line="328" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx" mobile={this.props.form.getFieldValue("mobile")} validateMobile={this.validateMobile} triggerRef={this.bindRef} type="register" className="message-code" />
            </Form.Item> : null}
          <Form.Item data-inspector-line="337" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx">
            {
            /* 密码 */
          }
            {getFieldDecorator('password', {
            rules: [{
              required: true,
              message: '密码不能为空!'
            }],
            initValue: password
          })(<Input.Password data-inspector-line="342" data-inspector-column="15" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx" placeholder="请输入密码" onChange={e => {
            this.setState({
              password: e.target.value
            });
          }} prefix={<i data-inspector-line="345" data-inspector-column="22" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx" className="iconfont iconmima"></i>} suffix={visible => visible ? <i data-inspector-line="346" data-inspector-column="44" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx" className="iconfont iconliulan"></i> : <i data-inspector-line="346" data-inspector-column="86" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx" className="iconfont iconbukejian-"></i>} />)}
          </Form.Item>
          {provCityCountyFlag && <Form.Item data-inspector-line="350" data-inspector-column="34" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx">
              {getFieldDecorator('citys', {
            rules: [{
              required: true,
              message: '请选择地址!'
            }]
          })(<Cascader data-inspector-line="354" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx" fieldNames={{
            value: 'label'
          }} options={city} placeholder="请选择地址" onChange={this.chooseProvCityCounty} />)}
            </Form.Item>}
          {registerConfig && registerConfig.registerAgreementFlag == 1 ? <Form.Item data-inspector-line="359" data-inspector-column="74" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx">
              {
            /* 用户协议 */
          }
              <Checkbox data-inspector-line="361" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx" checked={userAgreementChecked} onChange={e => {
            this.setState({
              userAgreementChecked: e.target.checked
            });
          }}>我已阅读并同意<span data-inspector-line="361" data-inspector-column="142" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx" className="register-agree-protocol" onClick={this.goToProcotol}>《用户协议》</span></Checkbox>
            </Form.Item> : null}
          <Form.Item data-inspector-line="365" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx">
            <Button data-inspector-line="366" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\LoginRegister\\RegisterBox\\index.jsx" type="primary" className="login-button" htmlType="submit">注册</Button>
          </Form.Item>
        </Form>
        {
        /* <Button type="primary" shape="round" ghost>获取验证码</Button> */
      }
        {
        /* 注册按钮 */
      }
      </div>;
  }

}
export default Form.create()(RegisterBox);